/**
 * Error state component for error displays.
 * 
 * @module components/ui/ErrorState
 */

import { AlertCircle, RefreshCw } from 'lucide-react';
import type { ErrorStateProps } from '../../types';

/**
 * Error state display for error scenarios.
 * 
 * @param props - ErrorState properties
 * @returns ErrorState element
 */
export function ErrorState({
  title = 'Something went wrong',
  message,
  onRetry,
}: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <div className="p-4 bg-error-100 rounded-full mb-4">
        <AlertCircle className="h-8 w-8 text-error-600" />
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-2">{title}</h3>
      <p className="text-sm text-gray-500 max-w-md mb-6">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="btn-secondary inline-flex items-center gap-2"
        >
          <RefreshCw className="h-4 w-4" />
          Try again
        </button>
      )}
    </div>
  );
}
